import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.h2`
  font-size: 34px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.02em;
  text-align: left;
  color: var(--primary-dark-two);
  margin: 0px 0;
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Tab = styled.div`
  display: flex;
  gap: 8px;
  background: var(--white);
  padding: 8px;
  border-radius: 15px;
  margin-bottom: 15px;
`;

export const TabButton = styled.button`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  background: var(--white);
  border: 1px solid var(--primary-dark-two);
  color: var(--primary-dark-two);
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  height: 44px;
  border-radius: 15px;

  &.active {
    background: var(--primary-dark-two);
    color: var(--white);
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const Div = styled.div``;
